import { NAME } from "./constants";

export const GET_USER_LOCKS = NAME + "GET_USER_LOCKS";
export const GET_LOCK_USERS = NAME + "GET_LOCK_USERS";
export const GET_USER_BY_EMAIL = NAME + "GET_USER_BY_EMAIL";
export const GET_LOCK_INFORMATION = NAME + "GET_LOCK_INFORMATION";
export const CREATE_ACCESS = NAME + "CREATE_ACCESS";
export const RESET_STORE = NAME + "RESET_STORE";
